import type { TicketData } from '../types'

/**
 * The ticket, in one line.
 *
 * This was a five-row table: internal id, number, subject, email, status. The
 * agent is looking at that ticket in Desk while they read it, so the table
 * repeated what was already on their screen — and led with a nineteen-digit
 * id that means nothing to anyone. What is worth saying is which ticket the
 * panel thinks it is on, in case it is on the wrong one. Not its status: Desk
 * shows that a line above, and a pill here read as a control.
 */
export function TicketCard({ ticket }: { ticket: TicketData | null }) {
  if (!ticket?.id) {
    return <p className="sub">Open a ticket to generate a reply.</p>
  }

  return (
    <p className="ticket-line">
      {ticket.ticketNumber && <span className="ticket-no">#{ticket.ticketNumber}</span>}
      <span className="ticket-subject">{ticket.subject || 'No subject'}</span>
    </p>
  )
}
